import React from 'react'
import resolveLink from 'src/utils/resolveLink'
import { Link } from 'gatsby';

const Logo = (props) => {
    const classes = "col-span-1 flex justify-center items-center h-28"
    // Doing this to avoid annoying console warning about alt tags
    const img = props.image
    return (props.target?.cached_url && props.target?.linktype !== 'url') ? (
        <Link to={resolveLink(props.target?.cached_url)} className={classes}>
           <picture><img src={img?.filename} alt={img?.alt}/></picture>
        </Link>
    ) : (props.target?.cached_url && props.target?.linktype === 'url') ?
    (
        <a href={props.target?.cached_url} target="_blank" rel="noreferrer" className={classes}>
           <picture><img src={img?.filename} alt={img?.alt}/></picture>
        </a>
    ) :
    (
        <div className={classes}>
            <picture><img src={img?.filename} alt={img?.alt}/></picture>
        </div>
    )
}

export default Logo